import _ from 'lodash'
import request from '@/utils/request'
import { v2Host } from '@/config/host'

/**
 * 获取应用信息接口
 * http://playable.dev.com:8067/system/app_category/list?doc=system/app.go#%2fsystem%2fapp%2finfo
 * @param {{app_url: string}} params
 */
export function fetchAppInfo(params) {
  const id = params.id
  let url = `${v2Host}/system/app/info`
  if (id) {
    params = _.omit(params, ['id'])
    url = `${v2Host}/system/app/info?id=${id}`
  }
  params = _.omit(params, ['id'])
  return request({
    url: url,
    method: 'get',
    params: params
  })
}

export function fetchAppInfoList(params) {
  return request({
    url: `${v2Host}/system/app/list`,
    method: 'get',
    params: params
  })
}

/**
 * 获取应用id
 * http://playable.dev.com:8067/system/app_category/list?doc=system/app.go#%2fsystem%2fapp%2fcreate
 * @param {{name: string, package_name: string, platform: string, app_url: string, app_icon: string, cat_ids: string}} params
 */
export function createAppInfo(params) {
  return request({
    url: `${v2Host}/system/app/create`,
    method: 'post',
    data: params
  })
}

export function updateAppInfo(data) {
  const id = data.id
  data = _.omit(data, ['id'])
  // 如果更新时，icon_file是http(s)协议，则不进行更新图标
  // if (data.icon_file && /^https?:\/\//.test(data.icon_file)) {
  //   data = _.omit(data, ['icon_file'])
  // }
  return request({
    url: `${v2Host}/system/app/update?id=${id}`,
    method: 'post',
    data: data
  })
}
/**
 * 强制同步应用信息
 * @param {Object} params
 * @param {String} params.app_id 需要更新的应用id
 * @param {String} params.app_url 需要更新的应用商店
 * @param {String} params.language 需要更新的语言
 */
export function syncAppInfo(data) {
  return request({
    url: `${v2Host}/system/app/sync`,
    method: 'post',
    data: data
  })
}
